"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Button = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
require("./Button.css");
var classnames_1 = __importDefault(require("classnames"));
var MDIcon_1 = require("../../components/MDIcon");
var buttonClasses = ["primary", "secondary", "tertiary", "link", "critical"];
var oldButtonClasses = ["success", "info", "default", "warning", "danger", "solid-primary", "solid-primary-raised", "solid-secondary", "outline-primary", "outline-secondary", "outline-secondary-raised", "rounded-solid", "rounded-outline", "icon", "text", "text-link", "inline-outline-secondary", "solid-primary-pill", "solid-secondary-pill", "solid-outline-raised-pill", "raised-secondary", "solid-secondary", "outline-secondary-raised", "solid-primary-raised"];
var getButtonClassType = function (str) {
  if (str.includes("link")) return "link";
  if (str.includes("text")) return "tertiary";
  if (str.includes("primary")) return "primary";
  if (str.includes("secondary")) return "secondary";
  if (str.includes("tertiary")) return "tertiary";
  if (str.includes("critical")) return "critical";
  return "secondary";
};
(0, MDIcon_1.preloadIcons)("loading");
var Button = function (_a) {
  var children = _a.children,
    _b = _a.htmlType,
    htmlType = _b === void 0 ? "button" : _b,
    _c = _a.type,
    type = _c === void 0 ? "secondary" : _c,
    _d = _a.small,
    small = _d === void 0 ? false : _d,
    _e = _a.large,
    large = _e === void 0 ? false : _e,
    className = _a.className,
    uppercase = _a.uppercase,
    _f = _a.spinner,
    spinner = _f === void 0 ? false : _f,
    rest = __rest(_a, ["children", "htmlType", "type", "small", "large", "className", "uppercase", "spinner"]);
  //@ts-ignore
  if (type === "icon") {
    console.error("ERROR: \"".concat(type, "\" button type is deprecated. Use <IconButton/> instead."));
  }
  //@ts-ignore
  if (!buttonClasses.includes(type)) {
    console.error("ERROR: \"".concat(type, "\" button type is deprecated. Valid types are: ").concat(JSON.stringify(buttonClasses)));
  }
  type = getButtonClassType(type);
  var cn = (0, classnames_1.default)("vsx-btn", type, className, {
    "sm": small,
    "lg": large,
    "uppercase": uppercase !== false
  });
  return (0, jsx_runtime_1.jsxs)("button", __assign({
    type: htmlType,
    className: cn,
    role: "button"
  }, rest, {
    children: [(0, jsx_runtime_1.jsx)("div", __assign({
      className: (0, classnames_1.default)("vsx-btn-child", spinner && "vsx-btn-child-hidden")
    }, {
      children: children
    })), spinner && (0, jsx_runtime_1.jsx)("div", __assign({
      className: "vsx-btn-spinner"
    }, {
      children: (0, jsx_runtime_1.jsx)(MDIcon_1.MDIcon, {
        icon: "loading",
        size: 24,
        animation: "spin"
      })
    }))]
  }));
};
exports.Button = Button;